import { createSelector } from 'reselect';

import { TInitialState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

export const selectResultMessage = createSelector(
    [
        (state: TInitialState) => state.result,
    ],
    ({ status, message }) => {
        if (status === EResultPopupStatus.ERROR) {
            return {
                title: 'Ваша заявка не отправилась',
                text: 'Это какая-то ошибка. Пожалуйста, попробуйте еще раз или напишите нам в чат.',
            };
        }

        const [title, text] = message.split('.');

        return { title, text };
    },
);
